"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullSync = fullSync;
exports.syncUnionBase = syncUnionBase;
exports.syncUnionBasePage = syncUnionBasePage;
exports.syncUnionUser = syncUnionUser;
exports.syncUnionUserPage = syncUnionUserPage;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 工会数据同步 API
 */

// 手动触发全量同步
function fullSync() {
  return (0, _request.default)({
    url: '/admin/union-sync/full',
    method: 'POST'
  });
}

// 手动触发工会基本信息同步
function syncUnionBase() {
  return (0, _request.default)({
    url: '/admin/union-sync/union-base',
    method: 'POST'
  });
}

// 手动触发工会用户同步
function syncUnionUser() {
  return (0, _request.default)({
    url: '/admin/union-sync/union-user',
    method: 'POST'
  });
}

// 分页同步工会基本信息
function syncUnionBasePage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union-sync/union-base/page',
    method: 'POST',
    params: {
      current: params.current || 1,
      size: params.size || 100
    }
  });
}

// 分页同步工会用户
function syncUnionUserPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union-sync/union-user/page',
    method: 'POST',
    params: {
      current: params.current || 1,
      size: params.size || 100
    }
  });
}